
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/templates/Onboarding/components/preloaders';
import { LandingLayout } from '@/components/layouts/LandingLayout';
import { createNonLocalizedPageGetServerSideProps } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const ForBusinessLanding = dynamic(async () => await import('@/templates/Landing/ForBusiness/ForBusinessLanding'), {
    loading: LoaderScreen,
});
const index: React.FC = () => {
    return (<LandingLayout title='AI-Powered Design Solutions for Businesses | Elevate Your Brand with Lift' description='Discover how Lift’s AI design tools can transform your business. Create stunning visuals, marketing materials, and social media content effortlessly. Elevate your brand with our easy-to-use platform designed for businesses of all sizes.' ogTitle='Transform Your Business with AI-Powered Design | Lift for Businesses' ogDescription='Elevate your brand with Lift’s AI design solutions. Create eye-catching visuals and marketing materials in minutes. Perfect for businesses looking to enhance their online presence and engage customers effectively.'>
			<ForBusinessLanding />
		</LandingLayout>);
};
export default index;
const getServerSideProps = createNonLocalizedPageGetServerSideProps('/for-businesses');

    async function __Next_Translate__getServerSideProps__1a1a20bb8af__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/for-businesses/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb8af__ as getServerSideProps }
  